<template>
  <div class="switcher__wrapper">
    <UiText
      v-if="$slots.left"
      font="body-caption"
      tag="span"
      color="typography-body02"
    >
      <slot name="left" />
    </UiText>
    <label :for="id" class="switcher">
      <input
        :id="id"
        v-bind="$attrs"
        type="checkbox"
        class="switcher__input visually-hidden"
        :checked="!!val"
        @change="onChange"
      />
      <span class="switcher__ellipse" />
    </label>
    <UiText
      v-if="$slots.right"
      tag="span"
      font="body-caption"
      color="typography-body02"
    >
      <slot name="right" />
    </UiText>
  </div>
</template>
<script>
export default {
  name: 'BaseSwitcher',
  props: {
    // eslint-disable-next-line vue/require-prop-types
    value: { default: false },
    id: { type: String },
    prevent: { type: Boolean },
  },
  data() {
    return {
      val: null,
    }
  },
  watch: {
    value: {
      immediate: true,
      handler() {
        this.val = this.value
      },
    },
  },
  methods: {
    onChange(e) {
      if (this.prevent) {
        this.val = e.target.checked = this.val
        return
      }
      this.val = e.target.checked
      this.$emit('input', e.target.checked)
      this.$emit(e.target.checked ? 'true' : 'false')
    },
  },
}
</script>

<style lang="scss" scoped>
$switcher-width: 40px;
$switcher-height: 24px;
.visually-hidden {
  position: absolute;
  width: 1px;
  height: 1px;
  margin: -1px;
  padding: 0;
  overflow: hidden;
  border: 0;
  clip: rect(0 0 0 0);
}
.switcher {
  display: flex;
  cursor: pointer;

  &__ellipse {
    position: relative;
    flex-shrink: 0;
    width: $switcher-width;
    height: $switcher-height;
    background-color: var(--neutral-100);
    border: 1px solid transparent;
    border-radius: 50px;
    transition: 0.3s all;

    &:hover {
      background-color: var(--neutral-200);
    }

    &::before {
      position: absolute;
      top: 2px;
      left: 2px;
      width: 18px;
      height: 18px;
      background-color: var(--secondary-800);
      border-radius: 50%;
      box-shadow: 0 4px 6px 0 rgba(0, 0, 0, 0.1);
      transition-duration: 0.3s;
      content: '';
    }
  }

  &__input {
    appearance: none;
  }

  &__input:focus-visible + &__ellipse {
    border-color: var(--neutral-600);
    box-shadow: 0 0 0 4px rgba(252, 194, 0, 0.15);
  }

  &__input:disabled + &__ellipse {
    background-color: $gray-tr-50;
    pointer-events: none;

    &::before {
      background-color: $gray-500;
    }
  }

  &__input:checked + &__ellipse {
    background-color: $yellow-600;

    &::before {
      background-color: $black-500;
      transform: translateX(16px);
    }

    &:hover {
      border-color: $yellow-700;
    }
  }

  &__input:checked:disabled + &__ellipse {
    background-color: $yellow-900;
    border-color: $yellow-800;

    &::before {
      background-color: $gray-900;
    }
  }
  &__wrapper {
    display: flex;
    gap: 8px;
    align-items: center;
  }
}
</style>
